import { Button, Typography } from "@mui/material";

export default function SubmitButton({ text, disabled }) {
  return (
    <Button
      type="submit"
      size="small"
      variant="contained"
      disabled={disabled}
      sx={{
        bgcolor: "#EA5069",
        width: "100%",
        p: "0.7em",
        transition: "color 0.5s ease-in-out, background-color 0.5s ease-in-out",
      }}
    >
      <Typography
        variant="button"
        sx={{
          color: "#FFF",
        }}
      >
        {text}
      </Typography>
    </Button>
  );
}
